//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FeatureCompareTable from '@/components/elements/FeatureCompareTable.vue'
export default {
  components: { FeatureCompareTable }
}
